import { render, staticRenderFns } from "./modalAddGiveawayPopup.vue?vue&type=template&id=7b13b1c2&scoped=true&"
import script from "./modalAddGiveawayPopup.vue?vue&type=script&lang=js&"
export * from "./modalAddGiveawayPopup.vue?vue&type=script&lang=js&"
import style0 from "./modalAddGiveawayPopup.vue?vue&type=style&index=0&id=7b13b1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13b1c2",
  null
  
)

export default component.exports